import React from 'react';

// Inlined from information.inline.svg so it can be styled with `fill` in emphasis.scss
const InformationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    aria-hidden="true"
  >
    <path
      d="M256.002,182.774c-12.718,0-21.761,5.37-21.761,13.283V303.73c0,6.782,9.044,13.565,21.761,13.565
      c12.152,0,22.043-6.783,22.043-13.565V196.057C278.045,188.144,268.154,182.774,256.002,182.774z"
    />
    <path
      d="M256.002,116.361c-13,0-23.174,9.326-23.174,20.065c0,10.739,10.174,20.348,23.174,20.348
      c12.718,0,22.892-9.609,22.892-20.348C278.894,125.688,268.719,116.361,256.002,116.361z"
    />
    <path
      d="M256,0C134.398,0,36,98.348,36,219.873c0,99.231,65.333,181.626,153.417,209.609l50.032,73.747
      C243.171,508.715,249.37,512,256,512s12.829-3.285,16.551-8.771l50.032-73.747C410.706,401.486,476,319.061,476,219.873
      C476,98.271,377.523,0,256,0z M304.645,393.099c-4.555,1.274-8.51,4.12-11.165,8.033L256,456.376l-37.479-55.243
      c-2.656-3.913-6.611-6.76-11.166-8.033C132.377,372.135,76,303.181,76,219.873C76,120.69,156.748,40,256,40
      s180,80.69,180,179.873C436,303.264,379.54,372.158,304.645,393.099z"
    />
  </svg>
);

export default InformationIcon;
